import styled from '@emotion/styled';
import _Tab from '@material-ui/core/Tab';

import theme from '../../../theme';
import { SPACING_REGULAR } from '../../constant/spacing';

const Tab = styled(_Tab)({
  minWidth: 72,
  marginRight: SPACING_REGULAR,
  color: theme.palette.text.primary,
  ':disabled': {
    color: theme.palette.text.disabled,
  },
});

export default Tab;
